/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import * as yup from 'yup'
import { Field } from 'react-trazo-forms/dist/FormField'

import { Values} from 'react-trazo-forms'
import { i18n } from '../../../../providers/Locale/localeProvider'
import { regionOptions, countryOptions, getValue, messages } from '../../../../helpers/forms'

// Options
const AccepNewsletter = () => ([
  { key: '1', value: '1', label:'Acepto recibir correos de Purina' }
])

const coursesOptions = () => ([
  { key: 'CERTIFICACION EN RCP RECOVER', value: 'CERTIFICACION EN RCP RECOVER', label: i18n._('CERTIFICACION EN RCP RECOVER') },
  { key: 'MANIOBRAS CLINICAS AVANZADAS DE EMERGENCIAS', value: 'MANIOBRAS CLÍNICAS AVANZADAS DE EMERGENCIAS', label: i18n._('MANIOBRAS CLÍNICAS AVANZADAS DE EMERGENCIAS') },
  { key: 'POCUS ULTRASONIDO EN EMERGENCIA', value: 'POCUS ULTRASONIDO EN EMERGENCIA', label: i18n._('POCUS ULTRASONIDO EN EMERGENCIA') },
  { key: 'COMUNICACIÓN Y HABILIDADES BLANDAS EN ER', value: 'COMUNICACIÓN Y HABILIDADES BLANDAS EN ER', label: i18n._('COMUNICACIÓN Y HABILIDADES BLANDAS EN ER') },
  { key: 'DIALISIS PERITONEAL', value: 'DIÁLISIS PERITONEAL', label: i18n._('DIÁLISIS PERITONEAL') },
])

const genderOptions = () => ([
  { key: 'male', value: 'Masculino', label: i18n._('Masculino') },
  { key: 'female', value: 'Femenino', label: i18n._('Femenino') },
])

const roleOptions = () => ([
  { key: 'proffesional', value: 'Profesional', label: i18n._('Profesional') },
  { key: 'student', value: 'Estudiante', label: i18n._('Estudiante') },
])

const ageOptions = () => ([
  { key: '18 a 25 años', value: '18 a 25 años', label: i18n._('18 a 25 años') },
  { key: '26 a 40 años', value: '26 a 40 años', label: i18n._('26 a 40 años') },
  { key: '41 a 65 años', value: '41 a 65 años', label: i18n._('41 a 65 años') },
  { key: 'Mayor a 65 años', value: 'Mayor a 65 años', label: i18n._('Mayor a 65 años') },
])

const congressOptions = () => ([
  { key: 'congreso', value: 'Asistiré sólo al congreso', label: i18n._('Asistiré sólo al congreso') },
  { key: 'curso', value: 'Asistiré sólo a un taller de pago', label: i18n._('Asistiré sólo a un taller de pago') },
  { key: 'congreso y curso ', value: 'Asistiré al congreso y a un taller adicional de pago', label: i18n._('Asistiré al congreso y a un taller adicional de pago') },
])

const PuyehueOptions = () => ([
  { key: 'Pago Particular', value: 'Pago Particular', label: 'Pago Particular' },
  { key: 'Agrovet', value: 'Agrovet', label: 'Agrovet' },
  { key: 'Anasac', value: 'Anasac', label: 'Anasac' },
  { key: 'Boehringer Ingelheim', value: 'Boehringer Ingelheim', label: 'Boehringer Ingelheim' },
  { key: 'Diprovet', value: 'Diprovet', label: 'Diprovet' },
  { key: 'Dragpharma', value: 'Dragpharma', label: 'Dragpharma' },
  { key: 'Elanco', value: 'Elanco', label: 'Elanco' },
  { key: 'Gepsa', value: 'Gepsa', label: 'Gepsa' },
  { key: 'Idexx', value: 'Idexx', label: 'Idexx' },
  { key: 'Leguer', value: 'Leguer', label: 'Leguer' },
  { key: 'Ludipek', value: 'Ludipek', label: 'Ludipek' },
  { key: 'MSD', value: 'MSD', label: 'MSD' },
  { key: 'MV', value: 'MV', label: 'MV' },
  { key: 'Propac', value: 'Propac', label: 'Propac' },
  { key: 'Purina Proplan', value: 'Purina Proplan', label: 'Purina Proplan' },
  { key: 'Royal Canin', value: 'Royal Canin', label: 'Royal Canin' },
  { key: 'Skedu', value: 'Skedu', label: 'Skedu' },
  { key: 'Veterquimica', value: 'Veterquimica', label: 'Veterquimica' },
  { key: 'Zoetis', value: 'Zoetis', label: 'Zoetis' },
])

const PanamaOptions = () => ([
  { key: 'Pago Particular', value: 'Pago Particular', label: 'Pago Particular' },
  { key: 'IDEXX', value: 'IDEXX', label: 'IDEXX' },
  { key: 'RoMa MASCOTA', value: 'RoMa MASCOTA', label: 'RoMa MASCOTA' },
  { key: 'MSD', value: 'MSD', label: 'MSD' },
  { key: 'BOEHRINGER', value: 'BOEHRINGER', label: 'BOEHRINGER' },
  { key: 'QVET', value: 'QVET', label: 'QVET' },
  { key: 'FAUNA PANAMA', value: 'FAUNA PANAMA', label: 'FAUNA PANAMA' },
  { key: 'NUTRISERVI', value: 'NUTRISERVI', label: 'NUTRISERVI' },
  { key: 'EQUIVET', value: 'EQUIVET', label: 'EQUIVET' },
  { key: 'PETWORD', value: 'PETWORD', label: 'PETWORD' },
  { key: 'DESEGO', value: 'DESEGO', label: 'DESEGO' },
])

const BasicOptions = () => ([
  { key: 'PAGADO PARTICULAR', value: 'PAGADO PARTICULAR', label: 'PAGADO PARTICULAR' },
  { key: 'DESPA', value: 'DESPA', label: 'DESPA' },
  { key: 'AGROVET', value: 'AGROVET', label: 'AGROVET' },
  { key: 'HORIZON', value: 'HORIZON', label: 'HORIZON' },
  { key: 'ISENCE', value: 'ISENCE', label: 'ISENCE' },
  { key: 'HALLMARK', value: 'HALLMARK', label: 'HALLMARK' },
  { key: 'CHEMIE', value: 'CHEMIE', label: 'CHEMIE' },
  { key: 'COLMEVET', value: 'COLMEVET', label: 'COLMEVET' },
  { key: 'MILA', value: 'MILA', label: 'MILA' },
  { key: 'HOSER', value: 'HOSER', label: 'HOSER' },
  { key: 'DIPROVET', value: 'DIPROVET', label: 'DIPROVET' },
  { key: 'LEGUER', value: 'LEGUER', label: 'LEGUER' },
  { key: 'DROGUERIA ÑUÑOA', value: 'DROGUERIA ÑUÑOA', label: 'DROGUERIA ÑUÑOA' },
  { key: 'FARMINA CHILE', value: 'FARMINA CHILE', label: 'FARMINA CHILE' },
  { key: 'ANIMAL CARE', value: 'ANIMAL CARE', label: 'ANIMAL CARE' },
  { key: 'CONGRESO VETERINARIO', value: 'CONGRESO VETERINARIO', label: 'CONGRESO VETERINARIO' },
  { key: 'DATAMEDICA', value: 'DATAMEDICA', label: 'DATAMEDICA' },
  { key: 'DRAGPHARMA', value: 'DRAGPHARMA', label: 'DRAGPHARMA' },
  { key: 'ECD CONSULTORES', value: 'ECD CONSULTORES', label: 'ECD CONSULTORES' },
  { key: 'IDEXX', value: 'IDEXX', label: 'IDEXX' },
  { key: 'IFEVET', value: 'IFEVET', label: 'IFEVET' },
  { key: 'INABA', value: 'INABA', label: 'INABA' },
  { key: 'LUDIPEK', value: 'LUDIPEK', label: 'LUDIPEK' },
  { key: 'POWER DOG', value: 'POWER DOG', label: 'POWER DOG' },
  { key: 'PURINA', value: 'PURINA', label: 'PURINA' },
  { key: 'QVET', value: 'QVET', label: 'QVET' },
  { key: 'ROYAL CANIN', value: 'ROYAL CANIN', label: 'ROYAL CANIN' },
  { key: 'SERFIMER', value: 'SERFIMER', label: 'SERFIMER' },
  { key: 'ZOETIS', value: 'ZOETIS', label: 'ZOETIS' },
  { key: 'JOSERA', value: 'JOSERA', label: 'JOSERA' },
  { key: 'UNIV. SANTO TOMAS', value: 'UNIV. SANTO TOMAS', label: 'UNIV. SANTO TOMAS' },
  { key: 'UNIV. DE CHILE', value: 'UNIV. DE CHILE', label: 'UNIV. DE CHILE' },
  { key: 'UNIV. DE LAS AMÉRICAS', value: 'UNIV. DE LAS AMÉRICAS', label: 'UNIV. DE LAS AMÉRICAS' },
  { key: 'UNIVERSIDAD BERNARDO OHIGGINS', value: 'UNIVERSIDAD BERNARDO OHIGGINS', label: 'UNIVERSIDAD BERNARDO OHIGGINS' },
  { key: 'UNIVERSIDAD DEL ALBA', value: 'UNIVERSIDAD DEL ALBA', label: 'UNIVERSIDAD DEL ALBA' },
  { key: 'UNIVERSIDAD MAYOR', value: 'UNIVERSIDAD MAYOR', label: 'UNIVERSIDAD MAYOR' },
  { key: 'ANDRES BELLO', value: 'ANDRES BELLO', label: 'ANDRES BELLO' },
  { key: 'UNIVERSIDAD VIÑA DEL MAR', value: 'UNIVERSIDAD VIÑA DEL MAR', label: 'UNIVERSIDAD VIÑA DEL MAR' },
  { key: 'UNIVERSIDAD BERNARDO O ́HIGGINS', value: 'UNIVERSIDAD BERNARDO O ́HIGGINS', label: 'UNIVERSIDAD BERNARDO O ́HIGGINS' },
  { key: 'UNIVERSIDAD CATÓLICA DE CHILE', value: 'UNIVERSIDAD CATÓLICA DE CHILE', label: 'UNIVERSIDAD CATÓLICA DE CHILE' },
  { key: 'GABRICA', value: 'GABRICA', label: 'GABRICA' },
  { key: 'MSD', value: 'MSD', label: 'MSD' },
  { key: 'I SENS', value: 'I SENS', label: 'I SENS' },
  { key: 'SKEDU', value: 'SKEDU', label: 'SKEDU' },
  { key: 'CEVA', value: 'CEVA', label: 'CEVA' },
  { key: 'VITALCAN', value: 'VITALCAN', label: 'VITALCAN' },
  { key: 'PROA (Monge/ Champion/ Pet Care)', value: 'PROA (Monge/ Champion/ Pet Care)', label: 'PROA (Monge/ Champion/ Pet Care)' },
])


// Form definitions
export const informationInitialValues = (information?: any) => ({
  Email: getValue(information, 'Email', ''),
  FirstName: getValue(information, 'FirstName', ''),
  LastName: getValue(information, 'LastName', ''),

  Country: getValue(information, 'Country', undefined),
  Region: getValue(information, 'Region', undefined),

  CompanyName: getValue(information, 'CompanyName', ''),
  JobTitle: getValue(information, 'JobTitle', ''),

  AgeRange: getValue(information, 'AgeRange', undefined),
  Gender: getValue(information, 'Gender', ''),

  CouponCode: getValue(information, 'CouponCode', undefined),

  Becado: getValue(information, 'Becado', ''),
  BecadoTaller: getValue(information, 'BecadoTaller', ''),
  Newsletter: getValue(information, 'Newsletter', undefined),

  Voucher: getValue(information, 'Voucher', ""),
  VoucherCourse: getValue(information, 'VoucherCourse', ""),
  StudentCertificate: getValue(information, 'StudentCertificate', ""),
  FileALS: getValue(information, 'FileALS', ""),
  FileBLS: getValue(information, 'FileBLS', ""),

  AssistanceEvent: getValue(information, 'AssistanceEvent', ""),

  Phone: getValue(information, 'Phone', ""),
  Course: getValue(information, 'Course', ""),

  Role: getValue(information, 'Role', ""),
})

export const getInformationFields = (slug?: any) => {
  let options: any = () => []

  switch (slug) {
    case 'veterinario-puyehue-2023':
      options = PuyehueOptions
      break
    case 'veterinario-panama-2024':
      options = PanamaOptions
      break

    default:
      options = BasicOptions
      break
  }

  const fields: Field[] = [
    {
      name: 'FirstNames',
      placeholder: 'Ej: Marcelo',
      label: i18n._('Nombres'),
      type: 'text',
      readOnly: true
    },
    {
      name: 'LastNames',
      placeholder: 'Ej: Jara',
      label: i18n._('Apellidos'),
      type: 'text',
      readOnly: true
    },
    {
      name: 'Email',
      placeholder: 'Ej: marcelo@example.com',
      label: i18n._('Correo Electrónico Principal'),
      type: 'text',
      readOnly: true
    },

    {
      name: 'Country',
      placeholder: i18n._('Por favor, seleccione su país'),
      label: i18n._('Por favor, seleccione su país'),
      type: 'select',
      options: countryOptions,
    },
    {
      name: 'Region',
      placeholder: i18n._('Por favor, seleccione su región'),
      label: i18n._('Por favor, selecciona su región'),
      type: 'select',
      options: regionOptions,
      condition: (values: Values) => values.Country === 'Chile'
    },
    {
      name: 'AgeRange',
      placeholder: i18n._('Por favor, seleccione su rango Etario'),
      label: i18n._('Rango Etario'),
      type: 'select',
      options: ageOptions
    },
    {
      name: 'Gender',
      placeholder: i18n._('Selecciona tu sexo'),
      label: i18n._('Seleccione su sexo'),
      type: 'radio',
      options: genderOptions,
      extraProps: { columns: 3 }
    },
    {
      name: 'CouponCode',
      placeholder: i18n._('Ingresa un código de cortesía'),
      label: i18n._('Código de cortesía (opcional)'),
      type: 'text'
    },
    {
      name: 'CompanyName',
      placeholder: i18n._('Ej: Clínica Reñaca'),
      label: i18n._('Nombre de su organización o empresa'),
      type: 'text'
    },
    {
      name: 'JobTitle',
      placeholder: i18n._('Ej: Gerente de TI'),
      label: i18n._('¿Cuál es su cargo?'),
      type: 'text'
    },
    {
      name: 'Becado',
      placeholder: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa?'),
      label: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa?'),
      type: 'select',
      options: options,
      extraProps: { columns: 3 }
    },
    {
      name: 'Newsletter',
      placeholder: '',
      label: i18n._('Newsletter'),
      type: 'checkbox',
      options: AccepNewsletter
    },
    {
      name: 'FileALS',
      placeholder: '',
      label: "Subir certificado curso ALS",
      type: 'file'
    },
    {
      name: 'FileBLS',
      placeholder: '',
      label: "Subir certificado curso BLS",
      type: 'file'
    },
    {
      name: 'Phone',
      placeholder: 'Ej: 912345678',
      label: i18n._('Número de Teléfono'),
      type: 'text',
    },
    {
      name: 'Course',
      placeholder: i18n._('¿Desea inscribirse a un taller de pago adicional?'),
      // label: i18n._('¿Desea inscribirse a un taller de pago adicional?'),
      type: 'radio',
      options: coursesOptions,
      // extraProps: { columns: 3 }
    },
    {
      name: 'AssistanceEvent',
      placeholder: i18n._('Seleccione a que evento asistirá'),
      label: i18n._('Seleccione a que evento asistirá'),
      type: 'radio',
      options: congressOptions,
      // extraProps: { columns: 3 }
    },
    {
      name: 'BecadoTaller',
      placeholder: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa para el taller?'),
      label: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa para el taller?'),
      type: 'select',
      options: options,
      extraProps: { columns: 3 }
    },
    {
      name: 'Region',
      placeholder: i18n._('Por favor, seleccione su región'),
      label: i18n._('Por favor, selecciona su región'),
      type: 'select',
      options: regionOptions,
      condition: (values: Values) => values.Country === 'Chile'
    },
    {
      name: 'Role',
      placeholder: i18n._('Seleccione su rol'),
      label: i18n._('Seleccione su rol'),
      type: 'radio',
      options: roleOptions,
      extraProps: { columns: 3 }
    },
  ]
  return fields
}

export const informationValidationSchema = yup.object().shape({
  Country: yup.string()
    .required(messages.required),
  Region: yup.string()
    .when('Country', {
      is: 'Chile',
      then: yup.string().required(messages.required),
      otherwise: yup.string().notRequired(),
    }),
  JobTitle: yup.string()
    .required(messages.required),
  CompanyName: yup.string()
    .required(messages.required),
  Gender: yup.string()
    .required(messages.required),
  AgeRange: yup.string()
    .required(messages.required),
  Role: yup.string()
    .required(messages.required),
})